import { removedQuestionParts } from '../db/page-read'
import { readPageDocument } from '../db/page-document'
import type { Block } from '@w/content-blocks'
import type { ItemReadResource } from './entries'
import type { Unreadable } from './item-readers'

/** Retained parts belong to this qid, never to the whole composed page read. Undecodable parts are a placeholder. */
export async function readRemovedParts(resource: ItemReadResource, pageId: string, qid: string): Promise<Block[] | Unreadable> {
  let parts: Block[]
  try {
    // A cloze is inline: its removed node is the cloze alone, so the read wraps it in a paragraph to render as a page
    // block (as Clone does, learner-actions.ts); a bare cloze under content is NotAllowed in the block schema.
    parts = (await removedQuestionParts(resource.db, pageId, qid)).map((part): Block => part.type === 'cloze' ? { id: `removed-${part.id}`, type: 'p', children: [part] } : part)
    readPageDocument({ content: { children: parts } }, { title: '', kind: 'note', deletedAt: null, archived: false, translatable: false })
  } catch (error) {
    if (!(error instanceof SyntaxError) && !(error instanceof Error && /^(Invalid page (block|document|link)|Invalid question (block|options)|Structural page references must be local|Invalid structural page reference)/.test(error.message))) throw error
    return { unreadable: 'REMOVED_CONTENT', key: qid, pageId }
  }
  return parts
}
